import { useState } from 'react';

/**
 * ログイン情報記憶チェックボックスの状態管理用カスタムフック
 */
export const useStateChecked = () => {
	const [isChecked, setIsChecked] = useState(true); // ログイン情報を記憶するかどうかのチェックボックスの状態管理

	//  ログイン情報の記憶のチェックボックスを押下した際の処理
	const onChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			setIsChecked(true);
			return;
		}

		setIsChecked(false);
	};

	return {
		isChecked,
		onChangeCheckbox,
	};
};
